import { rCore } from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IInputAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError } from '../../../../models/StateModels';
import pSifreDegistir from '../../../../api/models/pSifreDegistir';

export const action_api_set_input = (
  body: pSifreDegistir | null | undefined
): IInputAction<pSifreDegistir> =>
  ActionFunctions.action_api_set_input(ActionSubTypes.API_SIFREDEGISTIR, true, body);

export const action_async_start = (body: pSifreDegistir): IPromiseAction<pSifreDegistir> =>
  ActionFunctions.action_async_start_promise(
    ActionSubTypes.API_SIFREDEGISTIR,
    new Api.User.SifreDegistir().Request(body),
    false,
    false,
    body
  );

export const action_async_complete = (
  data: rCore | null | undefined,
  error: IError | null | undefined
): IApiAction<rCore> =>
  ActionFunctions.action_async_complete_api<rCore>(ActionSubTypes.API_SIFREDEGISTIR, data, error);
